import React, { useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Alert, Button } from "@mui/material";

import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../../context/Auth/AuthContext";

const NEEDS_QR_STATUS = ["qrcode"];
const RECONNECTING_STATUS = ["PAIRING", "DISCONNECTED", "TIMEOUT", "OPENING"];

const ConnectionStatusBanner = () => {
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user } = useContext(AuthContext);
  const [needsQr, setNeedsQr] = useState([]);
  const [reconnecting, setReconnecting] = useState([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setNeedsQr(whatsApps.filter((w) => NEEDS_QR_STATUS.includes(w.status)));
      setReconnecting(
        whatsApps.filter((w) => RECONNECTING_STATUS.includes(w.status))
      );
    }, 2000);
    return () => clearTimeout(timer);
  }, [whatsApps]);

  if (!whatsApps || whatsApps.length === 0) return null;
  if (needsQr.length === 0 && reconnecting.length === 0) return null;

  const isAdmin = user?.profile === "admin";

  if (needsQr.length > 0) {
    const names = needsQr.map((w) => w.name).join(", ");
    return (
      <Alert
        severity="warning"
        variant="filled"
        style={{ borderRadius: 0 }}
        action={
          isAdmin ? (
            <Button
              component={RouterLink}
              to="/connections"
              color="inherit"
              size="small"
            >
              IR PARA CONEXÕES
            </Button>
          ) : null
        }
      >
        Conexão com o WhatsApp <b>{names}</b> foi perdida e precisa de um novo
        QR Code para reconectar.
      </Alert>
    );
  }

  const names = reconnecting.map((w) => w.name).join(", ");
  return (
    <Alert severity="info" variant="filled" style={{ borderRadius: 0 }}>
      Reconectando ao WhatsApp <b>{names}</b>... isso pode levar alguns
      instantes.
    </Alert>
  );
};

export default ConnectionStatusBanner;
